export enum dryerType {
  CYCLING_REFRIGERATED = 'Cycling Refridgerated',
  NON_CYCLING_REFRIGERATED = 'Non-Cycling Refridgerated',
  SUBFREEZING = 'Subfreezing',
  HIGH_TEMPERATURE_REFRIGERATED = 'High Temperature Refrigerated',
  DESICCANT = 'Desiccant',
  DESICCANT_MODULAR = 'Desiccant Modular',
}

export enum dryerCategory {
  AIR_COOLED = 'Air Cooled',
  WATER_COOLED = 'Water Cooled',
  HEATLESS = 'Heatless',
  HEATED = 'Heated',
}
